// import store from '@/store'
// import router from '@/router'
import {axiosInstance} from './axiosInstance'

export default {
  install: (Vue, options) => {
    Vue.prototype.$api = {
      get: axiosInstance.get,
      post: axiosInstance.post,
      put: axiosInstance.put,
      delete: axiosInstance.delete
    }
  },
}
